import resizeCornerIcon from 'Assets/images/resize-corner.svg';
import React from 'react';

export const ResizableCorner = () => {
  return <div className="ResizableCorner">
    <img src={resizeCornerIcon} alt="Resize Corner Icon" />
  </div>;
};
